import React from 'react';
import { Modal } from '@landr/maestro';
import * as Styled from './styled';

type SplitModalProps = {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
};

const SplitModal: React.FC<SplitModalProps> = ({
    children,
    isOpen,
    onClose,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <Modal.Content>
                <Styled.SectionWrapper>{children}</Styled.SectionWrapper>
            </Modal.Content>
        </Modal>
    );
};

export default SplitModal;
